<template>
    <servicos
        :permitirAprovar="false"
        :permitirReprovar="false"
        :permiteDetalhar="$temAcessoView('GESCON-FORN-SERV-00')"
        rotaDetalhar="Gescon_Fornecedores_Servicos_Detalhar"
        rotaListagem="Gescon_Fornecedores_Servicos_Listagem"
    ></servicos>
</template>

<script>
import ServicosServicos from './ServicosServicos'
import Servicos from '../../aprovadores/Comprometimentos'

export default {
    name: 'FornecedoresServicos',
    
    components: {
        Servicos
    },

    data() {
        return {
            servicosServicos: ServicosServicos
        }
    },

    provide() {
        return {
            servicosServicos: this.servicosServicos
        }
    }
}
</script>